import axios from 'axios';
import cfg_axios from '@/config/cfg_axios';

const SENSITIVE_KEY_RE =
  /(token|password|cvv|cvc|cryptogram|pan|primaryAccountNumber|deviceAccount)/i;

function sanitize(value) {
  if (value == null) return value;
  if (value instanceof Error) {
    return { name: value.name, message: value.message, stack: value.stack };
  }
  try {
    return JSON.parse(
      JSON.stringify(value, (key, val) => {
        if (typeof key === 'string' && SENSITIVE_KEY_RE.test(key)) {
          return '[REDACTED]';
        }
        return val;
      })
    );
  } catch (err) {
    return { serialization_error: err.message };
  }
}

class PaymentSystemLogger {
  static log(paymentSystem, event, data = {}, level = 'info') {
    const payload = {
      payment_system: paymentSystem,
      event,
      level,
      data: sanitize(data),
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    };

    const consoleMethod = level === 'error' ? 'error' : level === 'warn' ? 'warn' : 'log';
    // eslint-disable-next-line no-console
    console[consoleMethod](`[${paymentSystem}] ${event}`, data);

    axios
      .post(cfg_axios.base_url + '/payments/log', payload, {
        headers: { ...cfg_axios.headers, 'Content-Type': 'application/json' },
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error('[PaymentSystemLogger] send failed', err.message);
      });
  }

  static info(paymentSystem, event, data) {
    this.log(paymentSystem, event, data, 'info');
  }

  static warn(paymentSystem, event, data) {
    this.log(paymentSystem, event, data, 'warn');
  }

  static error(paymentSystem, event, data) {
    this.log(paymentSystem, event, data, 'error');
  }
}

export default PaymentSystemLogger;
